import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Changelog {
	getChanges(take = "") {
		return xget<{ changes: Omit<PGSchema.changelog, "descrip">[]; last: PGSchema.changelog }>(`/changelog`, { take: take ? "1" : "20" });
	}
	getchangelog(body: { id: PGSchema.changelog["id"] }) {
		return xget<{ change: PGSchema.changelog }>(`/changelog/${body.id}`);
	}
	addchange(body: Partial<Omit<PGSchema.changelog, "id" | "created_at">>) {
		return xhttp<{ changes: PGSchema.changelog }>(`/changelog`, "POST", body);
	}
	editChange(id: PGSchema.changelog["id"], body: Partial<Omit<PGSchema.changelog, "id" | "created_at">>) {
		return xhttp<{ changes: PGSchema.changelog }>(`/changelog/${id}`, "PATCH", body);
	}
	deleteChange(id: PGSchema.changelog["id"], body: { tags: string[]; version: string; descrip: string }) {
		return xhttp<{ changes: PGSchema.changelog }>(`/changelog/${id}`, "DELETE", body);
	}
}
